import Vue from 'vue'
import Router from 'vue-router'
import {Env_currentenv} from '../../config/myglobalenvConfig.js'

// 企业管理员相关
import CompanyMainroute from '@/view/CompanyUser/CompanyMainroute'
import CompanyMainPage from '@/view/CompanyUser/CompanyMainPage'
import EmPowerAsMember from '@/view/CompanyUser/EmPowerManage/EmPowerAsMember'
import manageAsMember from '@/view/CompanyUser/EmPowerManage/manageAsMember'
import EmPowerAsPro from '@/view/CompanyUser/EmPowerManage/EmPowerAsPro'
import manageAsPro from '@/view/CompanyUser/EmPowerManage/manageAsPro'
import companyInfo from '@/view/CompanyUser/companyManage/companyInfo'
import comMbManage from '@/view/CompanyUser/companyManage/comMbManage'
import CompanyPhoneBind from '@/view/CompanyUser/CompanyPhoneBind'
import CompanypersonInfo from '@/view/AccountData/PersonInfo'
import seeInviteHis from '@/view/CompanyUser/companyManage/seeInviteHis'
// 企业管理员支付和订单相关
import companyOrder from '@/view/CompanyUser/CompanyOrderPay/companyOrder'
import comOrderDetail from '@/view/CompanyUser/CompanyOrderPay/comOrderDetail'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
let router = new Router({
  mode: 'history', // 去掉url中的#
  routes: [
  {//404路由
    path: '*',
    name: 'NotFound',
    component: () => import('@/components/NotFoundPage'),
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '试用中心'
    },
    redirect: '/TrialCenter',
    component:() => import('@/view/saleTrialLayout/index.vue'),
    children:[
      {
          path: '/TrialCenter',
          name: 'TrialCenter',
          meta: {
            title: '试用中心'
          },
          component:() => import('@/view/TrialCenter/index.vue'),
      },
      {
        path: '/saleGoodsList',
        name: 'saleGoodsList',
        meta: {
          title: '试用中心'
        },
        component:() => import('@/view/SaleOnLine/SaleHomePage.vue'),
      },
    ]
  },
  // {
  //   path: '/TrialCenter',
  //   name: 'TrialCenter',
  //   meta: {
  //     title: '试用中心'
  //   },
  //   component:() => import('@/view/TrialCenter/index.vue'),
  // }, 
  // {
  //   path: '/saleGoodsList',
  //   name: 'saleGoodsList',
  //   meta: {
  //     title: '试用中心'
  //   },
  //   component:() => import('@/view/SaleOnLine/SaleHomePage.vue'),
  // },
  {
    path: '/HomeTrial',
    name: 'HomeTrial',
    meta: {
      title: '试用中心'
    },
    component:() => import('@/view/Home/HomeTrial.vue'),
    children:[
      {
        path: '/TrialCenterProDerail',
        name: 'TrialCenterProDerail',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/ProductDetails/TrialCenterProDerail')
      },
      {
        path: '/AddPersonInfo',
        name: 'AddPersonInfo',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/AddpersonInfo/addPersonInfo.vue')
      },
      {
        path: '/TrialApplyResult',
        name: 'TrialApplyResult',
        meta: {
          title: '个人中心'
        },
        component:()=>import('@/view/ProductDetails/TrialApplyResult')
      },
    ]
  },
  {//在线销售相关路由
    path: '/saleOnlineLayout',
    name: 'saleOnlineLayout',
    meta: {
      title: '在线销售'
    },
    component: () => import('@/view/SaleOnLine/SaleLayout.vue'),
    children:[
      {
        path:'/SaleGoodsDetail',
        name:'SaleGoodsDetail',
        meta:{
          title: '在线销售'
        },
        component:()=>import('@/view/SaleOnLine/SaleGoodsDetail')
      },
      {
        path:'/selectGoods',
        name:'selectGoods',
        meta:{
          title: '在线销售'
        },
        component:()=>import('@/view/SaleOnLine/selectGoods')
      },
      {
        path:'/ConfirmGoodsAndBillInfo',
        name:'ConfirmGoodsAndBillInfo',
        meta:{
          title: '在线销售'
        },
        component:()=>import('@/view/SaleOnLine/ConfirmGoodsAndBillInfo')
      },
      {
        path:'/SalePayPage',
        name:'SalePayPage',
        meta:{
          title: '在线销售'
        },
        component:()=>import('@/view/SaleOnLine/SalePayPage.vue')
      },
      {
        path:'/SalePayResult',
        name:'SalePayResult',
        meta:{
          title: '在线销售'
        },
        component:()=>import('@/view/SaleOnLine/SalePayResult.vue')
      },

    ]
  },
  {//注销账号路由
    path:'/personalogoffTippage',
    name:'personalogoffTippage',
    meta:{
      title: '个人中心'
    },
    component:()=>import('@/view/AccountBind/personalogoffTippage.vue')
  },
  {//注销企业账户
    path:'/companyLogoffTipage',
    name:'companyLogoffTipage',
    meta:{
      title: '个人中心'
    },
    component:()=>import('@/view/CompanyUser/companySetting/companyLogoffTipage.vue')
  },
  {// 企业成员相关路由
    path: '/corporatorMainRoute',
    name: 'corporatorMainRoute',
    meta: {
      title: '个人中心'
    },
    component: () => import('@/view/Corporator/corporatorMainRoute'),
    // redirect: '/comallProucctsAndSer',
    children: [{// 查看企业的产品和服务
      path: '/comallProucctsAndSer',
      name: 'comallProucctsAndSer',
      meta: {
        title: '个人中心'
      },
      component: () => import('@/view/Corporator/comallProucctsAndSer')
    },
    {
      path: '/co-cloudDisk',
      name: 'co-cloudDisk',
      meta: {
        title: '个人中心',
        keepAlive:true,
      },
      component: () => import('@/view/cloud-disk/CloudDisk')
    }
    ]
  },
  {//会议试用相关路由
    path:'/meetingMainRoute',
    name:'meetingMainRoute',
    meta: {
      title: '会议试用'
    },
    component:()=>import('@/view/MeetingTrial/meetingMainRoute'),
    redirect:'meetingProIntroduce',
    children: [{
      path: '/meetingProIntroduce',
      name: 'meetingProIntroduce',
      meta: {
        title: '会议试用'
      },
      component: () => import('@/view/MeetingTrial/meetingProIntroduce')
    },
    {
      path:'/meetingApplyResult',
      name:'meetingApplyResult',
      meta:{
        title: '会议试用'
      },
      component:()=>import('@/view/MeetingTrial/meetingApplyResult')
    }]
  },
  {//成员申请为企业成员相关路由
    path:'/applyMainRoute',
    name:'applyMainRoute',
    meta: {
      title: '个人中心'
    },
    component:()=>import('@/view/memberApplyRoutePage/applyMainRoute'),
    redirect:'applyNotice',
    children: [{
      path: '/applyNotice',
      name: 'applyNotice',
      meta: {
        title: '个人中心'
      },
      component: () => import('@/view/memberApplyRoutePage/applyNotice')
    },
    ]
  },

  {//企业管理员和企业子管理员登录身份判断路由
    path: '/companyRouteCallback',
    name: 'companyRouteCallback',
    component: () => import('@/view/CompanyUser/companyRouteCallback.vue'),
    meta: {
      title: '个人中心'
    },
  },
  {// 企业管理员相关路由
    path: '/CompanyMainroute',
    name: 'CompanyMainroute',
    component: CompanyMainroute,
    meta: {
      title: '个人中心'
    },
    redirect: '/CompanyMainPage',
    children: [{// 主页路由
      path: '/CompanyMainPage',
      name: 'CompanyMainPage',
      meta: {
        title: '个人中心'
      },
      component: CompanyMainPage
    },
    {// 所有产品和服务路由
      path: '/allProucctsAndSer',
      name: 'allProucctsAndSer',
      meta: {
        title: '个人中心'
      },
      component:()=>import('@/view/CompanyUser/allProductAndSer/index.vue')
    },
    {// 所有产品和服务路由
      path: '/company-cloudDisk',
      name: 'company-cloudDisk',
      meta: {
        title: '个人中心',
        keepAlive:true,
      },
      component:() => import('@/view/cloud-disk/CloudDisk')
    },
    {
      path: '/EmPowerAsMember',
      name: 'EmPowerAsMember',
      meta: {
        title: '个人中心'
      },
      component: EmPowerAsMember
    },
    {
      path: '/manageAsMember',
      name: 'manageAsMember',
      meta: {
        title: '个人中心'
      },
      component: manageAsMember
    },
    {
      path: '/EmPowerAsPro',
      name: 'EmPowerAsPro',
      meta: {
        title: '个人中心'
      },
      component: EmPowerAsPro
    },
    {
      path: '/manageAsPro',
      name: 'manageAsPro',
      meta: {
        title: '个人中心'
      },
      component: manageAsPro
    },
    {
      path: '/companyInfo',
      name: 'companyInfo',
      meta: {
        title: '个人中心'
      },
      component: companyInfo
    },
    {
      path:'/companyInfoDetail',
      name:'companyInfoDetail',
      meta:{
        title:'个人中心'
      },
      component:()=>import('@/view/CompanyUser/companyManage/companyInfoDetail')
    },
    {
      path: '/comMbManage',
      name: 'comMbManage',
      meta: {
        title: '个人中心'
      },
      component: comMbManage
    },
    {
      path:'/adminpermissionManage',
      name:'adminpermissionManage',
      meta:{
        title:'个人中心'
      },
      component:()=>import('@/view/CompanyUser/permissionManage/index.vue')
    },
    {
      path:'/companySetting',
      name:'companySetting',
      meta:{
        title:'个人中心'
      },
      component:()=>import('@/view/CompanyUser/companySetting/companysettingindex.vue')
    },
    {//注销企业账户
      path:'/companyLogoffAgreement',
      name:'companyLogoffAgreement',
      meta:{
        title: '个人中心'
      },
      component:()=>import('@/view/CompanyUser/companySetting/companyLogoffAgreement.vue')
    },
    {
      path:'/addorEditAdminGroup',
      name:'addorEditAdminGroup',
      meta:{
        title:'个人中心'
      },
      component:()=>import('@/view/CompanyUser/permissionManage/addorEditAdminGroup.vue')
    },
    {
      path:'/depEmpowerAllocation',
      name:'depEmpowerAllocation',
      meta:{
        title:'个人中心'
      },
      component:()=>import('@/view/CompanyUser/EmpowerAllocation/allocateindex.vue')
    },
    {
      path: '/inviteUser',
      name: 'inviteUser',
      meta: {
        title: '个人中心'
      },
      component:()=>import('@/view/CompanyUser/companyManage/inviteUser')
    },

    {
      path: '/seeInviteHis',
      name: 'seeInviteHis',
      meta: {
        title: '个人中心'
      },
      component: seeInviteHis
    },
    {
      path: '/seeMemberApply',
      name: 'seeMemberApply',
      meta: {
        title: '个人中心'
      },
      component:()=>import('@/view/CompanyUser/companyManage/seeMemberApply')
    },
    {
      path: '/applyDetail',
      name: 'applyDetail',
      meta: {
        title: '个人中心'
      },
      component:()=>import('@/view/CompanyUser/companyManage/applyDetail')
    },

    {
      path: '/CompanyPhoneBind',
      name: 'CompanyPhoneBind',
      meta: {
        title: '个人中心'
      },
      component: CompanyPhoneBind
    },
    {//企业管理员重置密码组件
      path: '/CompanySetPassword',
      name: 'CompanySetPassword',
      meta: {
        title: '个人中心'
      },
      component: ()=>import('@/view/AccountData/ResetPassword')
    },
    {
      path: '/CompanypersonInfo',
      name: 'CompanypersonInfo',
      meta: {
        title: '个人中心'
      },
      component: CompanypersonInfo
    },

    {
      path: '/companyOrder',
      name: 'companyOrder',
      meta: {
        title: '个人中心'
      },
      component: companyOrder
    },
    {
      path: '/comOrderDetail',
      name: 'comOrderDetail',
      meta: {
        title: '个人中心'
      },
      component: comOrderDetail
    },
    {//企业管理员消息通知
      path: '/companyMessage',
      name: 'companyMessage',
      meta: {
        title: '个人中心'
      },
      component: ()=>import('@/view/CompanyUser/messageAttention/companyMessage/index.vue')
    },
    {//企业管理员消息通知详情
      path: '/companyMessageDetail',
      name: 'companyMessageDetail',
      meta: {
        title: '个人中心'
      },
      component: ()=>import('@/view/CompanyUser/messageAttention/companyMessage/commessageDetail.vue')
    },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '构力云账号'
    },
    component: () => import('@/view/UCLogin/index.vue'),
    //component: Login
  },
  {
    path: '/CloudProductDetails',
    component: () => import('@/view/ProductDetails/index.vue'),
    children: [
      {
        path: '/OldPKPMCloudApp',
        name: 'OldPKPMCloudApp',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/ProductDetails/OldPKPMCloudApp')
      },
    ]
  },
  // 个人中心
  {
    path: '/HomePage',
    name: 'HomePage',
    component: () => import('@/view/home/Home'),
    meta: {
      title: '试用中心'
    },
    children: [
      {
        path: '/personalMainPage',
        name: 'personalMainPage',
        meta: {
          title: '试用中心'
        },
        component: () => import('@/view/ProductService/personalMainPagenew')
      },
      {
        path: '/personalToComAuth',
        name: 'personalToComAuth',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/personalToComAuth/personalToComAuth')
      },
      {
        path: '/TryOutRequest',
        name: 'TryOutRequest',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/ProductService/TryOutRequest')

      },
      {// 个人产品和服务
        path: '/perallproductAndSer',
        name: 'perallproductAndSer',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/ProductService/perallproductAndSer')
      },
      {
        path: '/personalOrderList',
        name: 'personalOrderList',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/OrderAndPay/personalOrderList')
      },
      {
        path: '/perOrderDetail',
        name: 'perOrderDetail',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/OrderAndPay/perOrderDetail')
      },
      {
        path: '/PersonInfo',
        name: 'PersonInfo',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/AccountData/PersonInfo')
      },
      {
        path:'/PersonInfoDetail',
        name:'PersonInfoDetail',
        meta:{
          title: '个人中心'
        },
        component:()=>import('@/view/AccountData/PersonInfoDetail')
      },
      {
        path: '/ResetPassword',
        name: 'ResetPassword',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/AccountData/ResetPassword')
      },
      { // 账号绑定相关
        path: '/securityCenter',
        name: 'securityCenter',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/AccountBind/PhoneReBind')
      },
      { // 账号绑定相关
        path: '/logoffAgreement',
        name: 'logoffAgreement',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/AccountBind/logoffAgreement.vue')
      },
      {//消息中心
        path:'/messageDetail',
        name:'messageDetail',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/messageCenter/messageDetail')
      },
      {//消息中心
        path:'/backlogDetail',
        name:'backlogDetail',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/messageCenter/backlogDetail')
      },
      {
        path:'/myMessage',
        name:'myMessage',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/messageCenter/myMessage')
      },
      {
        path:'/myBacklog',
        name:'myBacklog',
        meta: {
          title: '我的事项'
        },
        component: () => import('@/view/messageCenter/myBacklog')
      },
      {
        path:'/billAndAddressManage',
        name:'billAndAddressManage',
        meta: {
          title: '个人中心'
        },
        component: () => import('@/view/BillManage/billAndAddressManage')
      },
      // PKPM云盘
      {
        path: '/cloudDisk',
        name: 'cloudDisk',
        meta: {
          title: '个人中心',
          keepAlive:true
        },
        component: () => import('@/view/cloud-disk/CloudDisk')
      }
    ]
  },
  // FilePreview (用于云盘各项文件预览)
  {
    path: '/filePreview',
    name: 'filePreview',
    component: () => import('@/view/cloud-disk/FilePreview')
  },
  // FilePreview (用于查看别人分享的文件)
  {
    path: '/shareFilePreview',
    name: 'shareFilePreview',
    meta: {
      title: '个人中心'
    },
    component: () => import('@/view/cloud-disk/ShareFilePreview')
  },
  {
    path: '/UserAgreenment',
    name: 'UserAgreenment',
    component: () => import('@/view/UCLogin/UserAgreenment/index.vue'),
    meta: {
      title: '试用中心'
    }
  },
  // 云应用
  {
    path: '/cloud-application',
    name: 'CloudApplication',
    meta: {
      title: '云应用'
    },
    component: () => import('@/view/cloud-application')
  },
    // 对接小鹅通页面，ltw
    {
      path: '/WebLogin',
      name: 'LoginNew',
      component: () => import('@/view/GLXTLogin/LoginNew.vue')
    },
    {
      path: '/H5Login',
      name: 'H5Login',
      component: () => import('@/view/GLXTLogin/login/index.vue'),
      meta: {
        isH5: true
      }
    },
    {
      path: '/user-agreenment',
      name: 'UserAgreenment2',
      component: () => import('@/view/GLXTLogin/UserAgreenment.vue'),
      meta: {
        isH5: true
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('@/view/UCLogin/components/callback.vue'),
      meta: {
        isH5: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/view/UCLogin/components/logout.vue'),
      meta: {
        isH5: false
      }
    },
    
  ]
})
//判断是否是手机端
function _isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}
router.beforeEach((to, from, next) => {
   if (Env_currentenv=='production' && _hmt) { // 接入百度统计代码，勿删，正式环境需要用
    if (to.path) {
       _hmt.push(['_trackpageview'], to.fullPath)
     }
   }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.path === '/login'){
    console.log(to.query)
    if(_isMobile()){
      next({path:'/NVH5Login',query:to.query})
    }else {
      next({query:to.query})
    }
  }
  if(_isMobile()){
    if(!to.meta.isH5){
      if(to.path === '/WebLogin'){
        console.log(1)
        let query = Object.assign({},to.query)
        next({path: '/H5Login',query:query})
      }else{
        next()
      }
    }else {
      next()
    }
  }else {
    if(to.meta.isH5){
      if(to.path === '/H5Login'){
        let query = Object.assign({},to.query)
        next({path: '/WebLogin',query:query})
      }else{
        next()
      }
    }else {
      next()
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js